import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { CardVaultTransactionDetailContent } from './CardVaultTransactionDetailContent';

export async function generateStaticParams() {
    return [];
}

export default function CardVaultTransactionDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <CardVaultTransactionDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
